"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const SearchAddressDialog_1 = require("@/common/components/SearchAddressDialog");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ companyAddressForm, maxWidth768, }) {
    var _a;
    const { clearErrors, setValue, setFocus, formState: { errors }, } = companyAddressForm;
    const [showDaumPostcodeDialog, setShowDaumPostcodeDialog] = (0, react_1.useState)(false);
    const openDaumPostcodeDialog = () => setShowDaumPostcodeDialog(true);
    const closeDaumPostcodeDialog = () => setShowDaumPostcodeDialog(false);
    const onSearchAddressClick = () => {
        openDaumPostcodeDialog();
        clearErrors('root.noAddress');
    };
    const onSelectDaumPostcode = (daumAddress) => {
        const { zonecode, userSelectedType, roadAddress, address } = daumAddress;
        setValue('company_post_code', zonecode);
        setValue('company_address', userSelectedType === 'R' ? roadAddress : address);
        clearErrors('company_address_detail');
        closeDaumPostcodeDialog();
        setFocus('company_address_detail');
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "crdi_input_wrapper" }, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ sx: {
                    columnGap: '4px',
                    width: '100%',
                    height: '48px',
                    borderRadius: '12px',
                    color: 'var(--white)',
                    bgcolor: 'var(--gray-80) !important',
                }, onClick: onSearchAddressClick }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.LocationIconWhiteSvg, {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('주소 찾기') }))] })), ((_a = errors.root) === null || _a === void 0 ? void 0 : _a.noAddress) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 error-main" }, { children: errors.root.noAddress.message }))), (0, jsx_runtime_1.jsx)(SearchAddressDialog_1.SearchDaumPostcodeDialog, { open: showDaumPostcodeDialog, closeDialog: closeDaumPostcodeDialog, onSelectDaumPostcode: onSelectDaumPostcode, maxWidth768: maxWidth768 })] })));
}
exports.default = default_1;
